<template>
  <div>
    <row type="flex" justify="center" :gutter="20">
        <div class="container">
          <router-view />
        </div>
    </row>
  </div>
</template>
<script>
export default {
  name: "NoLoggedLayout",
  components: {
  },
  setup() {
  },
  mounted() {},
};
</script>
<style></style>
